export interface VisibleFilterType {
  visibility: server.dto.BooleanFilterSettings
}

export const initialVisibleFilter: VisibleFilterType = {
  visibility: "noFilter"
};